<template>
  <meeting-topic-timer :meetingId="$route.params.id"></meeting-topic-timer>
</template>

<script>
import MeetingTopicTimer from "../components/agenda/meeting-topic-timer-new/MeetingTopicTimer.vue";
export default {
  components: { MeetingTopicTimer },
  name: "MeetingTimer",
};
</script>

<style scoped>
.rounded-card {
  border-radius: 7px !important;
}
</style>